module.exports = __webpack_public_path__ + "static/media/3.34d41ec6.svg";